import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HradminRoutingModule } from './hradmin-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NativeGeocoder } from '@ionic-native/native-geocoder/ngx';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HradminRoutingModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    NativeGeocoder
  ]
})
export class HradminModule { }
